document.addEventListener('DOMContentLoaded', function() {
  // 初始化所有featured-blog组件的移动端滑动控制
  function initFeaturedBlogSliders() {
    const containers = document.querySelectorAll('.featured-blog-container');
    
    containers.forEach(container => {
      const slider = container.querySelector('.row.articles');
      const prevBtn = container.querySelector('.dl-arrow-prev');
      const nextBtn = container.querySelector('.dl-arrow-next');
      const items = slider.querySelectorAll('.columns');
      
      if (!slider || !prevBtn || !nextBtn || items.length === 0) return;
      
      let currentIndex = 0;
      let itemWidth = items[0].offsetWidth + 25; // 包括grid-gap
      
      function updateButtons() {
        // 更新上一个按钮状态
        if (currentIndex === 0) {
          prevBtn.classList.add('disabled');
          prevBtn.setAttribute('aria-disabled', 'true');
        } else {
          prevBtn.classList.remove('disabled');
          prevBtn.removeAttribute('aria-disabled');
        }
        
        // 更新下一个按钮状态
        if (currentIndex >= items.length - 1) {
          nextBtn.classList.add('disabled');
          nextBtn.setAttribute('aria-disabled', 'true');
        } else {
          nextBtn.classList.remove('disabled');
          nextBtn.removeAttribute('aria-disabled');
        }
      }
      
      function scrollToIndex(index) {
        const scrollLeft = index * itemWidth;
        slider.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
        currentIndex = index;
        updateButtons();
      }
      
      // 上一个按钮事件
      prevBtn.addEventListener('click', function() {
        if (!prevBtn.classList.contains('disabled') && currentIndex > 0) {
          scrollToIndex(currentIndex - 1);
        }
      });
      
      // 下一个按钮事件
      nextBtn.addEventListener('click', function() {
        if (!nextBtn.classList.contains('disabled') && currentIndex < items.length - 1) {
          scrollToIndex(currentIndex + 1);
        }
      });
      
      // 监听滚动事件，更新当前索引
      let scrollTimeout;
      slider.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const scrollLeft = slider.scrollLeft;
          const newIndex = Math.round(scrollLeft / itemWidth);
          if (newIndex !== currentIndex && newIndex >= 0 && newIndex < items.length) {
            currentIndex = newIndex;
            updateButtons();
          }
        }, 100);
      });
      
      // 处理窗口大小变化
      window.addEventListener('resize', function() {
        const newItemWidth = items[0].offsetWidth + 10;
        if (newItemWidth !== itemWidth) {
          itemWidth = newItemWidth;
          updateButtons();
        }
      });
      
      // 初始化按钮状态
      updateButtons();
    });
  }
  
  // 初始化
  initFeaturedBlogSliders();
  
  // 如果页面动态加载内容，可以调用此函数重新初始化
  window.featuredBlogInit = initFeaturedBlogSliders;
});